export enum GameType {
    POKEMON = 'pokemon',
    MAGIC = 'mtg',
    ONE_PIECE = 'one-piece-card-game',
    RIFTBOUND = 'riftbound-league-of-legends-trading-card-game'
}

export interface ICardPrice {
    condition: string
    printing: string
    language: string
    price: number
    actualPrice?: number
    lastUpdated?: number
    tcgplayerSkuId?: string
}

export interface ICard {
    _id: string
    id: string
    game: string
    justTcgId?: string
    name: string
    set: string
    setCode: string
    number: string
    rarity: string
    image?: string
    /** Admin override for `image`. Unset (not empty) when there is no override. */
    image_custom?: string
    description?: string
    price: ICardPrice
    averagePrice?: { usd: number }
    customPrice?: boolean
    variants?: unknown[]
    volatile?: boolean
    hidden?: boolean
    hiddenReason?: string
    /**
     * Set when duplicate resolution merged this card into another one. The admin
     * search deliberately returns merged cards (`includeMerged: true`) while public
     * search filters them out, so they show up here and have to be marked: a merged
     * card is skipped by the price sync and rejected by the price and art override
     * endpoints, which both match on `mergedInto: {$exists: false}`.
     *
     * All three are ObjectIds on the backend and arrive as strings.
     */
    mergedInto?: string
    mergedAt?: string
    mergedBy?: string
    createdAt?: string
    updatedAt?: string
}
